<div>
    <app-header-translator></app-header-translator>
    <div class="row">
        <div class="col-12 col-md-6">
            <button class="btn btn-cea-product" routerLink="/homeowner/general" id="homowner-general-btn-1" [queryParams]="{ reset: 'true' }">
                <span class="cea-product-image" [inlineSVG]="imageUrl('/files/assets/img/homeowner.svg')"></span>
                {{ 'START.HOMEOWNER_BUTTON' | translate }}
            </button>
        </div>
        <div class="col-12 col-md-6">
            <button class="btn btn-cea-product" routerLink="/condo/general" id="condo-general-btn-1" [queryParams]="{ reset: 'true' }">
                <span class="cea-product-image" [inlineSVG]="imageUrl('/files/assets/img/condo.svg')"></span>
                {{'START.CONDO_BUTTON' | translate }}
            </button>  
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-md-6">
            <button class="btn btn-cea-product" routerLink="/mobilehome/general" id="mobilehome-general-btn-1" [queryParams]="{ reset: 'true' }">
                <span class="cea-product-image" [inlineSVG]="imageUrl('/files/assets/img/mobilehome.svg')"></span>
                {{'START.MOBILEHOME_BUTTON' | translate }}
            </button>
        </div>
        <div class="col-12 col-md-6">
            <button class="btn btn-cea-product" routerLink="/renter/general" id="renter-general-btn-1" [queryParams]="{ reset: 'true' }">
                <span class="cea-product-image" [inlineSVG]="imageUrl('/files/assets/img/renter.svg')"></span>
                {{ 'START.RENTER_BUTTON' | translate }}
            </button>
        </div>
    </div>

    <div *ngIf="getIsWidget()" style="max-width: 25rem;">        
        <div class="row text-center" style="font-size: .8rem;">
            <div class="d-flex col-12 col-md-4 align-items-center">
                <img [src]="imageUrl('/files/assets/img/logo_footer.png')" width="140" alt="Logo California Earthquake Authority" title="Logo California Earthquake Authority" />
            </div>
            <div class="col-12 col-md-4">
                <span [innerHTML]="getAddress()"></span>
            </div>
            <div class="col-12 col-md-4">
                Rate Sets {{ getRates() }}<br />
                version {{ getVersion() }}
            </div>
        </div>
    </div>

    <div style="display: none">
        <div class="cea-visible-lg">
            LG
        </div>
        <div class="cea-visible-md">
            MD
        </div>
        <div class="cea-visible-sm">
            SM
        </div>
        <div class="cea-visible-xs">
            XS
        </div>
        <div class="cea-visible-xxs">
            XXS
        </div>
        {{screenWidth}}
    </div>
</div>
